function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "logo-labs_svg__a",
  x1: "31%",
  x2: "40%",
  y1: "2%",
  y2: "81%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#0C5495"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#0F5A9D"
})), React.createElement("linearGradient", {
  id: "logo-labs_svg__b",
  x1: "58%",
  x2: "183%",
  y1: "99%",
  y2: "-11%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#73F7DD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#5FBFC3"
})), React.createElement("linearGradient", {
  id: "logo-labs_svg__c",
  x1: "0%",
  x2: "102%",
  y1: "50%",
  y2: "42%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#73F7DD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#084E92"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#242B2E"
}, React.createElement("path", {
  d: "M74.795 15.996c2.288 0 4.386.667 5.848 1.557v3.72c-1.62-1.177-3.814-1.844-5.69-1.844-2.32 0-4.163 1.049-4.163 3.051 0 1.812 1.526 2.67 4.482 3.973 3.496 1.494 6.674 3.02 6.674 7.12 0 4.386-3.496 7.088-8.168 7.088-2.829 0-5.308-1.017-6.834-2.162v-3.973c1.653 1.59 4.164 2.702 6.58 2.702 2.51 0 4.545-1.303 4.545-3.496 0-1.97-1.717-2.893-4.768-4.228-3.242-1.43-6.293-2.892-6.293-6.833 0-4.1 3.274-6.675 7.787-6.675zm13.12-1.303v10.044h.064c.986-1.367 2.766-2.352 4.832-2.352 3.782 0 6.198 2.193 6.198 6.261v11.506h-3.75V29.79c0-2.67-1.145-3.973-3.497-3.973-2.098 0-3.846 1.24-3.846 3.751v10.584h-3.75v-25.46h3.75zm20.91 25.872c-3.974 0-7.788-3.591-7.788-9.058 0-5.53 3.814-9.122 7.787-9.122 2.543 0 4.768 1.271 6.007 3.4l.414-2.987h3.115v17.354h-3.115l-.414-2.987c-1.24 2.13-3.464 3.4-6.007 3.4zm.953-3.432c2.765 0 4.926-2.32 4.926-5.658 0-3.306-2.161-5.658-4.926-5.658-2.83 0-4.99 2.352-4.99 5.658 0 3.337 2.16 5.658 4.99 5.658zm11.786 3.02V22.797h2.987l.382 2.702h.063c1.176-2.194 3.306-2.893 4.863-2.893.477 0 .859.032 1.208.096v3.56a5.85 5.85 0 0 0-1.303-.128c-2.225 0-4.45 1.335-4.45 4.673v9.344h-3.75zm25.421-8.996c0 .54-.031 1.017-.095 1.462h-12.46c.509 3.052 2.83 4.832 5.88 4.832 1.971 0 3.91-.7 5.658-2.066v3.369c-1.78 1.208-3.814 1.811-6.039 1.811-5.69 0-9.122-3.687-9.122-9.026 0-5.563 3.878-9.154 8.518-9.154 4.196 0 7.66 3.02 7.66 8.772zM134.4 30.108h9.026c-.095-3.083-1.97-4.608-4.132-4.608-2.383 0-4.45 1.748-4.894 4.608zm30.507 10.044h-4.736l-7.279-8.677v8.677h-3.75v-25.46h3.75V30.84l7.152-8.041h4.577l-7.501 8.264 7.787 9.09zm15.155-8.995c0 .54-.032 1.017-.095 1.462h-12.46c.509 3.052 2.829 4.832 5.88 4.832 1.97 0 3.91-.7 5.658-2.066v3.369c-1.78 1.208-3.814 1.811-6.04 1.811-5.689 0-9.121-3.687-9.121-9.026 0-5.563 3.877-9.154 8.518-9.154 4.195 0 7.66 3.02 7.66 8.772zm-12.587-1.049h9.027c-.095-3.083-1.97-4.608-4.132-4.608-2.384 0-4.45 1.748-4.895 4.608zm29.617-7.31l-9.44 24.03h-3.782l2.988-7.248-6.516-16.782h4.068l4.355 12.523h.063l4.387-12.523h3.877z"
}), React.createElement("text", {
  fontFamily: "HeroNew-Medium, Hero New",
  fontSize: 8,
  fontWeight: 400,
  transform: "translate(65 -12)"
}, React.createElement("tspan", {
  x: 133,
  y: 41
}, "\xAE"))), React.createElement("path", {
  fill: "#1FC3B4",
  d: "M173.122 15V6.816h1.023v7.227h3.608V15h-4.631zm8.129.132c-1.397 0-2.706-1.221-2.706-3.102 0-1.903 1.309-3.113 2.706-3.113.858 0 1.672.429 2.123 1.232l.121-1.1h.825V15h-.825l-.121-1.089c-.451.803-1.265 1.221-2.123 1.221zm.209-.946c1.045 0 1.881-.88 1.881-2.167 0-1.276-.836-2.156-1.881-2.156-1.067 0-1.892.88-1.892 2.167 0 1.276.825 2.156 1.892 2.156zm5.72-7.986v3.894c.407-.759 1.243-1.177 2.068-1.177 1.397 0 2.684 1.199 2.684 3.113 0 1.892-1.309 3.102-2.706 3.102-.858 0-1.661-.418-2.112-1.221L186.993 15h-.825V6.2h1.012zm1.848 3.663c-1.045 0-1.87.88-1.87 2.156 0 1.287.825 2.167 1.87 2.167 1.067 0 1.892-.88 1.892-2.156 0-1.287-.825-2.167-1.892-2.167zm6.259-.946c.682 0 1.375.198 1.793.517v1.001c-.429-.363-1.078-.616-1.782-.616-.748 0-1.166.319-1.166.803 0 .528.517.726 1.32.957.913.264 1.947.561 1.947 1.76 0 1.089-.847 1.793-2.222 1.793-.77 0-1.507-.22-2.057-.66v-1.089a2.824 2.824 0 0 0 2.024.847c.803 0 1.265-.352 1.265-.88 0-.572-.561-.759-1.419-1.023-.979-.297-1.848-.616-1.848-1.661 0-1.001.825-1.749 2.145-1.749z"
}), React.createElement("path", {
  fill: "url(#logo-labs_svg__a)",
  d: "M32.565 27.633c5.509-.017 9.988 4.435 10.004 9.944v2.397c0 1.243-.036 5.788-.107 13.634a9.949 9.949 0 0 1-9.948 9.859c-5.449 0-9.87-4.409-9.886-9.857l-.047-15.934c-.016-5.53 4.454-10.027 9.984-10.043z",
  transform: "rotate(-144 30.425 44.037)"
}), React.createElement("path", {
  fill: "url(#logo-labs_svg__b)",
  d: "M23.114 2.553h.989a9.374 9.374 0 0 1 9.374 9.374v2.662c0 1.23.055 5.672.166 13.328.078 5.442-4.27 9.918-9.713 9.997h-.18c-5.55-.02-10.036-4.53-10.03-10.08l.02-15.919a9.374 9.374 0 0 1 9.374-9.362z",
  transform: "rotate(-144 21.532 18.721)"
}), React.createElement("path", {
  fill: "url(#logo-labs_svg__c)",
  d: "M7.423 20.122c1.934 8.861 14.57 13.605 20.872 2.687.275-.476.586-.919.863-1.372 1.55-2.534 3.558-4.44 6.023-5.715 4.807-2.49 10.723-.61 13.212 4.198a9.803 9.803 0 0 1 1.095 4.715l-.356 16.759-.336 4.833c-1.776-9.625-14.22-13.93-20.907-3.604-1.308 2.019-2.943 4.273-4.355 5.675-1.087 1.08-2.458 1.883-4.113 2.41C14.262 52.35 8.748 49.5 7.106 44.342a9.803 9.803 0 0 1-.455-3.369c.496-12.314.753-19.264.772-20.85z",
  transform: "rotate(35 32.91 26.14)"
}));

var SvgLogoLabs = function SvgLogoLabs(props) {
  return React.createElement("svg", _extends({
    width: 205,
    height: 58,
    viewBox: "0 0 205 58"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/logo-labs.bf39ab45.svg";
export { SvgLogoLabs as ReactComponent };